import gsap from "gsap";

export default class ChartStat {
  constructor(element) {
    this.element = element;
    this.active = false;
    this.inview = null;
    this.settings = null;
    this.value = 0;
    this.span = null;
    this.animationStarted = false;

    // Bind methods
    this.activate = this.activate.bind(this);
    this.run = this.run.bind(this);
    this.initObserver = this.initObserver.bind(this);

    // Wait until the document is fully loaded
    if (document.readyState === 'complete') {
      this.run();
    } else {
      window.addEventListener("load", this.run);
    }
  }

  run() {
    // Get chart settings from the element's attribute
    // this.settings = JSON.parse(this.element.getAttribute('chart'));
    this.value = parseInt(this.element.dataset.value);

    // Select the existing <span> inside the element
    this.span = this.element.querySelector('span');

    // If the span doesn't exist, exit early
    if (!this.span) {
      console.error('No <span> element found inside the chart element.');
      return;
    }

    // Initialize the MutationObserver to listen for the `is-inview` class
    this.initObserver();
  }


  initObserver() {
    // Observer to listen for the addition of `is-inview` class
    const observer = new MutationObserver(() => {
      if (this.element.classList.contains('is-inview') && !this.animationStarted) {
        this.animationStarted = true;
        this.activate();
      }
    });

    // Start observing the element's class attribute
    observer.observe(this.element, {
      attributes: true, // Watch for attribute changes
      attributeFilter: ['class'], // Only watch the 'class' attribute
    });
  }

  activate() {
    // If already activated, return early
    if (this.active) return;

    this.active = true;
    // this.element.classList.add(CLASS_ACTIVE);

    // Set up options for CountUp.js animation
    let options = {
      useEasing: true,
      useGrouping: false,
      separator: '',
      decimal: '',
    };

    // Start the animated count-up to the target value
    // new CountUp(this.span, 0, this.value, 0, 2, options).start();

    // Animate the number using GSAP's textContent animation
    gsap.fromTo(
      this.span, 
      { textContent: 0 }, // Start from 0
      {
        textContent: this.value, // Animate to the target value
        duration: 2, // Animation duration in seconds
        snap: { textContent: 1 }, // Increment by 1
        ease: "power2.out", // Smooth easing effect
      }
    );
  }

  // Clean up event listeners and OpInview instance
  disconnect() {
    window.removeEventListener("load", this.run);
    if (this.inview) {
      this.inview.disconnect();
    }
  }
}
